import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";

export default React.memo(({ paginationOptions, changePage }) =>{
    return (
    <>
    {paginationOptions.totalPages > 1 && (
        <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
            {paginationOptions.currentPage > 1 && <li className="page-item">
                <span className="page-link" onClick={() => changePage(paginationOptions.currentPage-2)}>
                <FontAwesomeIcon icon={faChevronLeft} className="purple" />
                </span>
            </li>}
            {[...Array(paginationOptions.totalPages).keys()].map(
                (i) => (
                <li
                    className={
                    paginationOptions.currentPage === i + 1
                        ? "page-item active"
                        : "page-item"
                    }
                    onClick={() => changePage(i)}
                >
                    <span className="page-link">
                    {i + 1}
                    </span>
                </li>
                )
            )}
            {paginationOptions.currentPage < paginationOptions.totalPages &&  <li className="page-item">
                <span className="page-link" onClick={() => changePage(paginationOptions.currentPage)}>
                <FontAwesomeIcon icon={faChevronRight} className="purple" />
                </span>
            </li>}
            </ul>
        </nav>
    )}
    </>
)
})
